'use strict';

const gtm = require('./modules/google').tagManager;
const giftRevealSection = document.querySelector('.js-gift-reveal');
const giftRevealButtons = document.querySelectorAll('.js-gift-reveal-btn');
const giftRevealCloseButtons = document.querySelectorAll('.js-giftopen-close-btn');
const phaseVideoElement = document.querySelector('.js-phase-video');
const revealElements = document.querySelectorAll('.js-reveal-element');
const revealDelay = 300;

const shouldInit = () => {
    return giftRevealSection !== null;
};

const giftRevealClick = () => {
    giftRevealButtons.forEach((singleBox) => {
        singleBox.addEventListener('click', function () {
            $('html, body').animate({
                scrollTop: $('.js-crm-hero').length > 0 ? $('.js-gift-reveal').offset().top : 0
            }, '800');
            if (singleBox.closest('.js-gift-reveal-event')){
                pushDataLayerEventCRM(singleBox.closest('.js-gift-reveal-event'));
            }
            this.closest('.phase-section').classList.add('phase-section-open');
            this.closest('.giftopen-single-box').classList.add('giftopen-single-box-open');
            this.classList.add('giftopen-btn-hide');
            const w = window.innerWidth / 2;
            this.closest('.giftopen-single-box').style.left = parseInt(w) + 'px';

            setTimeout(() => {
                this.parentElement.querySelector('.js-giftopen-close-btn').classList.add('giftopen-btn-show');
                this.parentElement.querySelector('.giftopen-timer').classList.add('giftopen-timer-show');
                $(this).parent().parent().find('.gift-reveal-body').css({'display': 'block'})
                    .animate({
                        top: '0',
                        opacity: '1'
                    }, {
                        queue: false,
                        duration: 'slow'
                    });
            }, 1000);
        });
    });
};

const giftRevealClose = () => {
    giftRevealCloseButtons.forEach(singleCloseButton => {
        singleCloseButton.addEventListener('click', function () {
            if (!$('.js-crm-hero').length > 0) {
                $('html, body').animate({
                    scrollTop: 0
                }, '800');
            }

            this.classList.remove('giftopen-btn-show');
            this.nextElementSibling.classList.remove('giftopen-timer-show');
            $(this).parent().parent().parent().find('.gift-reveal-body')
                .animate({
                        opacity: 0,
                        top: '20px'
                    },
                    1000,
                    function() {
                        $(this).removeAttr('style');
                    }
                );

            setTimeout(() => {
                this.closest('.phase-section').classList.remove('phase-section-open');
                this.closest('.giftopen-single-box').classList.remove('giftopen-single-box-open');
                this.parentElement.parentElement.querySelector('.js-gift-reveal-btn').classList.remove('giftopen-btn-hide');
            }, 1000);
        });
    });
};

const pushDataLayerEventCRM = function(event){
    const analyticsData = $(event.attributes['data-analytics']);
    if (!analyticsData) {
        return;
    }
    const analytics = JSON.parse(analyticsData[0].value);
    gtm.pushDataLayerEvent(analytics);
};

const initEvents = () => {
    giftRevealClick();
    giftRevealClose();
};

const initRevealElements = () => {
    prepareRevealElements();

    ['timeupdate', 'loadeddata'].forEach(evt => {
        phaseVideoElement.addEventListener(evt, (e) => {
            if (giftRevealSection.classList.contains('is-loading')) {
                e.target.pause();
                e.target.currentTime = 0;
                giftRevealSection.classList.remove('is-loading');
                fireRevealAnimations();

                setTimeout(() => {
                    e.target.play();
                }, 1400);

                cleanUpRevealElements();
            }
        }, false);
    });
};

const prepareRevealElements = () => {
    revealElements.forEach(el => {
        el.classList.add('reveal-base');
    });
};

const fireRevealAnimations = () => {
    revealElements.forEach((el, idx) => {
        if (el.hasAttribute('data-reveal-group')) {
            const group = el.dataset.revealGroup;
            const groupedEls = document.querySelectorAll(`[data-reveal-group='${group}']`);

            groupedEls.forEach((elInGroup) => {
                setTimeout(() => {
                    elInGroup.classList.add('reveal');
                }, idx * revealDelay);
            });
        } else {
            setTimeout(() => {
                el.classList.add('reveal');
            }, idx * revealDelay);
        }
    });
};

const cleanUpRevealElements = () => {
    setTimeout(() => {
        revealElements.forEach(el => {
            el.classList.remove('reveal-base', 'reveal');
        });
    }, revealElements.length * revealDelay);
};

const giftReveal = {
    init: () => {
        if (shouldInit()) {
            initEvents();
            initRevealElements();
        }
    }
};

module.exports = giftReveal;
